import { TOption } from '../components/select/select-lined';
import { IPagination } from './pagination.types';
import { TOperationStatus } from './redux-operation';

export enum ModalState {
  opened = 'opened',
  closed = 'closed',
}

export interface TagsPageState {
  getTagsRequestStatus?: TOperationStatus;
  tags: TagItem[];
  pagination: IPagination;
  errorMessage: string;
  successMessage: string;

  activeTag: TagItem | null;
  drawerStatus: ModalState;
  submitting: boolean;
  deleteModalStatus: ModalState;
}

export type TTagSettingsItem = 'videocall' | 'chat';

export interface TagItem {
  id: string;
  name: string;
  abbreviation: string;
  color: string;
  settings?: TTagSettingsItem[];
}

export enum FormValueNames {
  tagName = 'tags_name',
  abbreviation = 'tags_abbreviation',
  color = 'tags_color',
  settings = 'tags_settings',
}

export interface FormValues {
  [FormValueNames.tagName]: string;
  [FormValueNames.abbreviation]: string;
  [FormValueNames.color]: string;
  [FormValueNames.settings]: TOption;
}

export type TCreateTagData = {
  name: string;
  abbreviation: string;
  color: string;
  settings: TTagSettingsItem[];
};

export type TUpdateTagData = {
  id: string;
  data: {
    name: string;
    abbreviation: string;
    color: string;
  };
};

export interface ITagsPaginationArgs {
  page: number;
  pageSize: number;
  sortBy: 'name' | 'createdAt';
  direction: 'ASC' | 'DESC';
  paginated?: boolean;
}
